export var valuesSlideBackgroundSizingMethod = ["Stretching", "WidthDepenent", "HeightDependent", "MaxOfWidthAndHeightDependent", "MinOfWidthAndHeightDependent", "Covering", "SizeDependent"];
/*

*/ 
//# sourceMappingURL=SlideBackgroundSizingMethod.js.map